import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        case 'godt-at-vide':
            nextPage = 'hvem';
            break;
        case 'hvem':
            if (getValueOrDefault(formConfig, formValues, 'whoIsInjured').value === 'employeeOrOwner') {
                nextPage = 'om-den-syge';
            } else {
                nextPage = 'hvilken-skade';
            }
            break;
        case 'om-den-syge':
            nextPage = 'hvilken-skade';
            break;
        case 'hvilken-skade':
            if (getValueOrDefault(formConfig, formValues, 'damageType').value === 'illness') {
                nextPage = 'om-sygdommen';
            } else {
                nextPage = 'om-tilskadekomsten';
            }
            break;
        case 'om-sygdommen':
            nextPage = 'om-sygemeldingen';
            break;
        case 'om-tilskadekomsten':
            nextPage = 'om-sygemeldingen';
            break;
        case 'om-sygemeldingen':
            nextPage = 'sygemeldingens-varighed';

            break;
        case 'sygemeldingens-varighed':
            nextPage = 'oplysninger-om-laege';
            break;
        case 'oplysninger-om-laege':
            nextPage = 'dokumentation';
            break;
        case 'dokumentation':
            nextPage = 'virksomhedsoplysninger';
            break;
        case 'virksomhedsoplysninger':
            nextPage = 'forsikringsmaegler';
            break;

        case 'forsikringsmaegler':
            nextPage = 'om-virksomheden';
            break;

        case 'om-virksomheden':
            nextPage = 'andet-selskab';
            break;

        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                nextPage = 'hvilket-selskab';
            } else {
                nextPage = 'om-dig';
            }
            break;

        case 'hvilket-selskab':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;
        case 'resume':
            nextPage = undefined;
            break;
        default:
            console.log('# curPageId=', curPageId);
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
